module.exports = __webpack_public_path__ + "static/media/proj15_img8.bc7fdc32.jpg";